import dayjs from "dayjs";
import packageJson from "../../package.json";
import { log } from "./common.logger";

/**
 * Compare current app version with the latest version from meta.json.
 * Returns true if a newer version is available.
 * @returns
 */
export const checkAppVersion = async (): Promise<boolean> => {
	try {
		const response = await fetch(`/meta.json?ts=${Date.now()}`, { cache: "no-store" });
		const meta = await response.json();

		const latestDate = meta.buildDate;
		const currentDate = packageJson.buildDate;

		const momLatestDateTime = dayjs(latestDate * 1000);
		const momCurrentDateTime = dayjs(currentDate * 1000);

		const isNewer = momLatestDateTime.isAfter(momCurrentDateTime);

		log(
			`Current: ${momCurrentDateTime.format("YYYY-MM-DD HH:mm:ss")}, Latest: ${momLatestDateTime.format(
				"YYYY-MM-DD HH:mm:ss",
			)}`,
		);

		if (isNewer) {
			log("🚀 New version available!");

			const isStandalone =
				(window.navigator as any).standalone === true ||
				window.matchMedia("(display-mode: standalone)").matches;

			if (isStandalone) {
				alert("Please close and reopen the app to get the latest version.");
			} else {
				if (window.caches) {
					window.caches.keys().then((names) => {
						for (const name of names) {
							window.caches.delete(name);
						}
					});
				}
				window.location.reload();
			}
		} else {
			log("App is up to date.");
		}

		return isNewer;
	} catch (err) {
		log("Failed to check app version exception:", err);
		return false;
	}
};
